import type {Values} from '@wix/devzai-utils-common';
import {DoppeBusinessEntity} from './doppe-business-entity';
import {DoppeAutoServiceType} from './doppe-auto-service-type';

export const DoppeServicesExternalDataSourceType = {
    LatestWixServices: 'LatestWixServices',
    LatestHoppServices: 'LatestHoppServices',
    WixServicesByCategories: 'WixServicesByCategories',
    HoppServicesByCategories: 'HoppServicesByCategories',
} as const;

export type DoppeServicesExternalDataSourceType = Values<typeof DoppeServicesExternalDataSourceType>;

export type DoppeServicesExternalDataSource =
    | {
    type: typeof DoppeServicesExternalDataSourceType.LatestWixServices;
} | {
    type: typeof DoppeServicesExternalDataSourceType.LatestHoppServices;
} | {
    type: typeof DoppeServicesExternalDataSourceType.WixServicesByCategories;
    categoryIds: string[];
} | {
    type: typeof DoppeServicesExternalDataSourceType.HoppServicesByCategories;
    categoryIds: string[];
};

export function doppeServicesExternalDataSourceResolveBusinessEntityReferences(
    externalDataSource: DoppeServicesExternalDataSource
) {
    switch (externalDataSource.type) {
        case DoppeServicesExternalDataSourceType.LatestWixServices: {
            return {businessEntity: DoppeBusinessEntity.WixAutoServicesList, id: DoppeAutoServiceType.Latest}
        }
        case DoppeServicesExternalDataSourceType.LatestHoppServices: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoServicesList, id: DoppeAutoServiceType.Latest}
        }
        case DoppeServicesExternalDataSourceType.WixServicesByCategories: {
            return {businessEntity: DoppeBusinessEntity.WixAutoServicesList, id: DoppeAutoServiceType.Categories, metadata: {categoryIds: externalDataSource.categoryIds}}
        }
        case DoppeServicesExternalDataSourceType.HoppServicesByCategories: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoServicesList, id: DoppeAutoServiceType.Categories, metadata: {categoryIds: externalDataSource.categoryIds}}
        }
    }
}